import React from 'react';
import SEO from "../common/SEO";
import HeaderOne from '../common/header/HeaderOne';
/* eslint-disable no-unused-vars -- components used in JSX below */
import ServiceOne from "../elements/service/ServiceOne";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import TeamFour from "../elements/team/TeamFour";
import TimelineTwo from "../elements/timeline/TimelineTwo";
import BrandFour from '../elements/brand/BrandFour';
/* eslint-enable no-unused-vars */
import Separator from "../elements/separator/Separator";
import CalltoActionFive from "../elements/calltoaction/CalltoActionFive";
import FooterTwo from '../common/footer/FooterTwo';
import ScrollAnimation from "react-animate-on-scroll";
import WhatWeDo from '../elements/about/WhatWeDo';
import ProductsWeManufacture from '../elements/about/ProductsWeManufacture';
import AboutLegacy from '../elements/about/AboutLegacy';


const BannerData = [
    {
        image: "/images/bg/bg-image-20.jpg",
        title: "KR Power Supports Pvt Ltd - Global Electrical Solutions",
        description: "KR Power Supports Pvt Ltd is a trusted name in Electrical Contracting, Cable Tray Manufacturing, and Panel Board Solutions since 1995. With over 30 years of industry expertise, we have grown into one of the industry’s reliable manufacturers and service providers for industrial electrical infrastructure."
    },
]
const AboutUs = () => {
    return (
        <>

            <SEO title="about us" />
            <main className="page-wrapper">
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-not-transparent" />


                {/* Start Slider Area  */}
                <div className="slider-area slider-style-8 height-650">
                    {BannerData.map((data, index) => (
                        <div key={index} className="single-slide">
                            <div className="container">
                                <div className="row align-items-center">
                                    <div className="col-lg-12">
                                        <div className="inner text-center">
                                            <span className="subtitle theme-gradient">About Us</span>
                                            <h1 className="title" style={{ fontFamily: 'Times New Roman, serif', fontSize: '3.5rem' }} dangerouslySetInnerHTML={{__html: data.title}}></h1>
                                            <p className="description" dangerouslySetInnerHTML={{__html: data.description}}></p>
                                            <div className="button-group mt--30">
                                                <a className="btn-default btn-large round" target="_blank" href="/products" rel="noopener noreferrer">Explore Now</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {/* End Slider Area  */}

                <Separator />

                <AboutLegacy/>
                
                <Separator />

                <WhatWeDo/>
                
                <Separator />
                
                <ProductsWeManufacture/>

                <Separator />

                {/* Start Service Area  */}
                {/* <div className="rn-service-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = "What we can do for you"
                                    title = "Services provide for you."
                                    description = "There are many variations of passages of Lorem Ipsum available, <br /> but the majority have suffered alteration."
                                    />
                            </div>
                        </div>
                        <ServiceOne 
                            serviceStyle = "service__style--1 bg-color-blackest radius mt--25"
                            textAlign = "text-center"
                            />
                    </div>
                </div> */}
                {/* End Service Area  */}
 {/* Start Timeline Area  */}
 {/* <div className="rwt-timeline-area rn-section-gap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "Way Of Working"
                                        title = "Our Working Process"
                                        description = "Delivering smart, reliable solutions through a skilled and experienced team."
                                    />
                                    {/* At Jaz Infotech, we follow a clear, collaborative, and results-driven process to turn your ideas<br /> into powerful digital solutions. From planning to delivery, every step is focused on quality, transparency, and your success. */}
                            {/* </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-10 offset-lg-1 mt--50">
                                <TimelineTwo   />
                            </div>
                        </div>
                    </div> 
                </div> */}



        

                <Separator />

                {/* Start Elements Area  */}
                {/* <div className="rwt-team-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--20">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = "Our Corporate Team."
                                    title = "Corporate Team Member."
                                    description = ""
                                />
                            </div>
                        </div>
                        <TeamFour column="col-lg-6 col-xl-3 col-md-6 col-12 mt--30" teamStyle="team-style-three" />
                    </div>
                </div> */}
                {/* End Elements Area  */}

                {/* Start Brand Area  */}
                {/* <div className="rwt-brand-area rn-section-gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = "OUR CLIENTS"
                                        title = "Brands That Believe in Us."
                                        description = ""
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 mt--10">
                                    <BrandFour brandStyle="brand-style-2 variation-2" />
                                </div>
                            </div>
                        </div>
                    </div> */}
                    {/* End Brand Area  */}

                {/* Why Choose Us Section */}
                <div className="rn-splite-style rn-section-gap">
                    <div className="container">
                        <div className="split-wrapper">
                            <div className="row no-gutters radius-10 align-items-center">
                                <div className="col-lg-12 col-xl-6 col-12">
                                    <div className="thumbnail image-left-content">
                                        <img src="./images/about/about8.webp" alt="Global electrical panel board manufacturers" />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-xl-6 col-12">
                                    <div className="split-inner">
                                        <ScrollAnimation 
                                            animateIn="fadeInUp"
                                            animateOut="fadeInOut"
                                            animateOnce={true}>
                                            <h4 className="title">Why Choose Us</h4>
                                        </ScrollAnimation>
                                        <ScrollAnimation 
                                            animateIn="fadeInUp"
                                            animateOut="fadeInOut"
                                            animateOnce={true}>
                                            <ul className="split-list">
                                                <li>- 30+ Years of Industry Excellence</li>
                                                <li>- ISO-Grade Manufacturing Standards</li>
                                                <li>- Dedicated R&D and Quality Testing</li>
                                                <li>- Timely Delivery & Pan-India Service</li>
                                                <li>- Skilled Team of Engineers, Supervisors & Technicians</li>
                                                <li>- Customer-First Approach with Transparent Work Process</li>
                                            </ul>
                                        </ScrollAnimation>
                                        <ScrollAnimation 
                                            animateIn="fadeInUp"
                                            animateOut="fadeInOut"
                                            animateOnce={true}> 
                                            <p className="description">Our success is built on quality, commitment, and innovation. Through continual 
                                                improvement and strong leadership, KR Power Supports stands firm 
                                                as a trusted partner for industries across India.</p>
                                        </ScrollAnimation>
                                        <ScrollAnimation 
                                            animateIn="fadeInUp"
                                            animateOut="fadeInOut"
                                            animateOnce={true}>
                                            <div className="view-more-button mt--35">
                                                <a className="btn-default" href="/contact">Contact With Us</a>
                                            </div>
                                        </ScrollAnimation>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Why Choose Us Section */}



                <Separator />

                {/* Start Call To Action Area  */}
                <div className="rwt-callto-action-area rn-section-gap">
                    <div className="wrapper">
                        <CalltoActionFive />
                    </div>
                </div>
                {/* End Call To Action Area  */}

                <FooterTwo />
                {/* <Copyright /> */}
            </main>
        </>
    )
}

export default AboutUs;
